import React from 'react';

import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { useTheme } from '@zenbusiness/zui/styles';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import { reportMarkdownComponents } from '#client/components/utils/markdownComponents';

import * as Styled from './ReportSection.style';

const BUBBLE_TITLE = 'Why This Works For You';
/**
 * Individual report section component with icon, title, and content
 * @param {object} props - Component props
 * @param {React.ReactElement} props.icon - Icon component for the section
 * @param {string} props.title - Section title
 * @param {string} props.content - Section content text
 */
function ReportSection({ icon, title, content }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Styled.ReportSectionRoot>
      {!isMobile && icon && <Styled.SectionIcon>{icon}</Styled.SectionIcon>}
      <Styled.SectionHeader isbubble={title === BUBBLE_TITLE ? 'true' : undefined}>
        <Styled.SectionTitleSection>
          {isMobile && icon && <Styled.SectionIcon>{icon}</Styled.SectionIcon>}
          <Styled.SectionTitle mb={1} size="md">
            {title}
          </Styled.SectionTitle>
        </Styled.SectionTitleSection>

        <Styled.SectionContent size="md">
          <ReactMarkdown
            components={reportMarkdownComponents}
            rehypePlugins={[rehypeRaw]}
            viewType={title === BUBBLE_TITLE ? 'report' : 'default'}
          >
            {content}
          </ReactMarkdown>
        </Styled.SectionContent>
      </Styled.SectionHeader>
    </Styled.ReportSectionRoot>
  );
}

ReportSection.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
};

export default ReportSection;
